import { IonIcon } from "@ionic/react";
import React from "react";
import { caretUp, caretDown, checkmark } from "ionicons/icons";

import { BOX_TEMPLATE } from "../../constants/boxDashboard";

import styles from "./BoxTemplateSelector.module.scss";

export interface BoxTemplateSelectorProps {
  preset: string;
  handleChangePreset: (args: { [key: string]: any }) => void;
}

const BoxTemplateSelector = (props: BoxTemplateSelectorProps) => {
  const defaultText = props.preset
    ? BOX_TEMPLATE[props.preset].title
    : "テンプレートから選ぶ";
  const defaultOption = props.preset ? props.preset : "";

  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedTitle, setSelectedTitle] = React.useState(defaultText);
  const [selectedOption, setSelectedOption] = React.useState(defaultOption);

  return (
    <div className={styles.selector}>
      <div
        className={`${styles.labelArea} ${isOpen && styles.isOpen}`}
        onClick={() => setIsOpen(!isOpen)}
        tabIndex={0}
      >
        <span className={styles.label}>{selectedTitle}</span>
        <IonIcon
          icon={isOpen ? caretUp : caretDown}
          className={styles.arrowIcon}
        />
      </div>
      {isOpen && (
        <ul className={styles.menu} tabIndex={0}>
          {Object.entries(BOX_TEMPLATE).map(([key, value]) => (
            <li
              key={key}
              className={styles.options}
              onClick={() => {
                if (key === selectedOption) {
                  props.handleChangePreset({ preset: "" });
                  setSelectedOption("");
                  setSelectedTitle("テンプレートから選ぶ");
                } else {
                  props.handleChangePreset({ preset: key });
                  setSelectedOption(key);
                  setSelectedTitle(value.title);
                }
                setIsOpen(false);
              }}
            >
              <span className={styles.optionLabel}>{value.title}</span>
              <p className={styles.optionDesc}>{value.desc}</p>
              {key === selectedOption && (
                <IonIcon src={checkmark} className={styles.checkIcon} />
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BoxTemplateSelector;
